/* src/app/modules/contact/contact/contact.component.css */
.import-card {
  padding: 24px;
  background-color: #fafafa;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-family: "Inter Tight", sans-serif;
}
.import-header {
  text-align: center;
  margin-bottom: 16px;
}
.import-header h2 {
  color: var(--cf-chrome);
  margin-bottom: 4px;
}
.import-header p {
  color: #666;
}
.import-body {
  padding-top: 16px;
}
.template-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}
.file-upload-label {
  display: inline-block;
  margin: 12px auto;
  padding: 10px 20px;
  border: 2px dashed #ccc;
  border-radius: 6px;
  background-color: #fff;
  cursor: pointer;
  font-size: 14px;
  color: #444;
  text-align: center;
  transition: border-color 0.3s;
}
.file-upload-label:hover {
  border-color: var(--cf-chrome);
  color: var(--cf-chrome);
}
.file-upload-label input[type=file] {
  display: none;
}
.file-name {
  text-align: center;
  font-size: 14px;
  color: #333;
  margin-top: 6px;
}
.spinner-container {
  text-align: center;
  padding: 20px;
}
.spinner-container p {
  margin-top: 12px;
  font-size: 16px;
  color: #555;
}
.preview-body {
  text-align: center;
  margin-top: 16px;
}
.preview-body p {
  margin-bottom: 12px;
}
.actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}
.preview-table {
  margin-top: 20px;
}
.file-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 1rem;
}
.file-upload-wrapper button {
  margin-bottom: 0.5rem;
}
.file-upload-wrapper .file-name {
  font-size: 0.9rem;
  color: #666;
}
.import-card {
  margin-bottom: 0 !important;
}
.mat-mdc-card {
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}
.hover-row:hover {
  background-color: #f5f5f5;
  transition: background-color 0.3s;
}
.text-success {
  color: #28a745;
}
.text-danger {
  color: #dc3545;
}
.mat-mdc-form-field {
  font-size: 0.9rem;
}
.btn-small {
  font-size: 0.85rem;
  padding: 4px 10px;
  min-width: 80px;
}
.cf-contact-splash {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
  min-width: 340px;
}
.cf-contact-splash__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.cf-contact-splash__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: #e3fd64;
}
.cf-contact-splash__dots {
  display: flex;
  gap: 8px;
}
.cf-contact-splash__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: 0.3;
  animation: cf-contact-pulse 1.2s ease-in-out infinite;
}
.cf-contact-splash__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.cf-contact-splash__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.cf-contact-splash__text {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}
@keyframes cf-contact-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.cf-contact-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
  flex-wrap: wrap;
}
.cf-contact-header__left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.cf-contact-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.cf-contact-header__icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--cf-brand-dark);
}
.cf-contact-header__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a1d23;
  line-height: 1.3;
}
.cf-contact-header__sub {
  margin: 2px 0 0;
  font-size: 12px;
  color: #6b7280;
}
.cf-contact-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.cf-contact-saved {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #16a34a;
}
.cf-contact-saved mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.cf-contact-btn-save {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 500 !important;
  gap: 6px;
}
.cf-contact-btn-close {
  color: #9ca3af !important;
}
.cf-contact-identity {
  padding: 16px 20px 8px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.cf-person-type {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.cf-type-toggle {
  width: 100%;
}
.cf-toggle-error {
  font-size: 11px;
  color: #dc2626;
  display: block;
  margin-top: 4px;
}
.cf-generate-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.cf-done-icon {
  color: #16a34a;
  vertical-align: middle;
  margin-left: 8px;
}
.cf-error-text {
  color: #dc2626;
  font-size: 13px;
  display: block;
  margin-top: 4px;
}
.cf-contact-content {
  padding: 0 !important;
  max-height: calc(70vh - 180px) !important;
  overflow-y: auto !important;
}
.cf-tab-group .mat-mdc-tab-header {
  position: sticky;
  top: 0;
  z-index: 5;
  background: #fff;
}
.cf-tab-body {
  padding: 20px;
}
.cf-section-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin: 16px 0 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e5e7eb;
}
.cf-section-label mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #e3fd64;
}
.cf-inline-dots {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}
.cf-inline-dots span {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: 0.4;
  animation: cf-idot 1.1s ease-in-out infinite;
}
.cf-inline-dots span:nth-child(2) {
  animation-delay: 0.18s;
}
.cf-inline-dots span:nth-child(3) {
  animation-delay: 0.36s;
}
@keyframes cf-idot {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.85);
  }
  40% {
    opacity: 1;
    transform: scale(1.1);
  }
}
.cf-add-btn {
  margin-top: 16px;
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 500 !important;
}
.cf-menu-danger,
.cf-menu-danger mat-icon {
  color: #dc2626 !important;
}
.cf-contact-footer {
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.cf-contact-footer__note {
  margin: 0;
  font-size: 12px;
  color: #9ca3af;
}
.cf-contact-footer__uid {
  display: flex;
  align-items: center;
  gap: 10px;
}
.cf-uid-btn {
  font-size: 12px;
  height: 30px;
  padding: 0 10px;
}
.cf-uid-value {
  font-size: 12px;
  color: #374151;
  background: #f3f4f6;
  padding: 3px 8px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}
.dlg-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}
.dlg-hdr__title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #1a1d23;
}
.dlg-hdr__close {
  color: #9ca3af !important;
  flex-shrink: 0;
}
.ct-t-splash {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 64px 32px;
  min-height: 200px;
}
.ct-t-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.ct-t-icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #e3fd64;
}
.ct-t-name {
  font-size: 16px;
  font-weight: 600;
  color: #1a1d23;
  line-height: 1.3;
}
.ct-t-actions {
  padding: 12px 20px !important;
  border-top: 1px solid #e5e7eb;
  gap: 8px;
}
.ct-t-name-sub {
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
  margin-top: 2px;
}
.ci-body {
  padding: 0 !important;
  max-height: calc(90vh - 130px) !important;
}
.ci-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 48px 24px;
  color: #9ca3af;
  font-size: 14px;
}
.ci-empty mat-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
}
/*# sourceMappingURL=contact.component.css.map */
